import { portal } from '../../assets/plugins/axios/axios.js';
import { HttpError } from '../../../src/business/httpError';
import { AxiosError } from 'axios';
import { PlatformEnum } from '../../enums/platform.enum';

class CentralConfigurationService {
  public getMaxFileSize = async (): Promise<Number> => {
    try {
      const { data } = await portal.get('?method=centralConfiguration.getMaxFileSize');
      return data.data;
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };

  public getLoginImportantInformation = async (platform: PlatformEnum): Promise<string | null> => {
    try {
      const { data } = await portal.get('?method=centralConfiguration.getLoginImportantInformation', {
        params: { platform },
      });
      return data.data;
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };
}

export const centralConfigurationService = new CentralConfigurationService();
